import getContext from 'recompose/getContext';
import PropTypes from 'prop-types';
import { compose, withHandlers, withPropsOnChange } from 'recompose';
import { connect } from 'react-redux';
import { change, getFormValues } from 'redux-form';
import { equals } from 'ramda';
import { get } from 'lodash';
import CustomerReminder from '../components/CustomerReminder';
import withMinuteOptions from '../../hoc/withMinuteOptions';
import {
  getUpdatedSecondReminder,
  isTimeIndeterminate,
  mergeLocationReminderTimeToAll,
  shouldUpdateSecondReminder,
  firstReminderFieldName,
  secondReminderFieldName,
} from '../customerReminderUtils';
import { LOCATIONS_ALL_ID } from '../../../main/barbers/containers/BrandBarber/constants';

const handleReminderChange = withPropsOnChange(
  (props, nextProps) => (
    !equals(props.barberReminderTime, nextProps.barberReminderTime) ||
    !equals(props.reminderTime, nextProps.reminderTime)
  ),
  (props) => {
    if (props.formSectionName === LOCATIONS_ALL_ID &&
      (isTimeIndeterminate(props.barberReminderTime) || isTimeIndeterminate(props.reminderTime))
    ) {
      const newAllLocationsSecondReminder = { hours: null, minutes: null };

      props.barberLocationIds.forEach((formSectionName) => {
        const firstReminderTime = get(props.formValues, props.getFirstReminderFieldName(formSectionName));
        const secondReminderTime = get(props.formValues, props.getSecondReminderFieldName(formSectionName));

        if (shouldUpdateSecondReminder(firstReminderTime, secondReminderTime)) {
          const newSecondReminder = getUpdatedSecondReminder(firstReminderTime, props.minuteOptions);
          props.change(
            props.form,
            props.getFirstReminderFieldName(formSectionName),
            newSecondReminder
          );

          mergeLocationReminderTimeToAll(newAllLocationsSecondReminder, newSecondReminder);
        } else {
          mergeLocationReminderTimeToAll(newAllLocationsSecondReminder, secondReminderTime);
        }
      });

      props.change(
        props.form,
        props.getSecondReminderFieldName(LOCATIONS_ALL_ID),
        newAllLocationsSecondReminder,
      );
    } else if (shouldUpdateSecondReminder(props.barberReminderTime, props.reminderTime)) {
      props.change(
        props.form,
        props.getSecondReminderFieldName(props.formSectionName),
        getUpdatedSecondReminder(props.barberReminderTime, props.minuteOptions)
      );
    }
  }
);

export const mapStateToProps = (state, ownProps) => {
  const form = ownProps._reduxForm.form;
  const formValues = getFormValues(form)(state);
  const barberLocationIds = Object.keys(formValues).filter(locationId => locationId !== LOCATIONS_ALL_ID);

  return {
    form,
    formValues,
    barberLocationIds,
    barberReminderTime: get(formValues, ownProps.getFirstReminderFieldName(ownProps.formSectionName)),
    reminderTime: get(formValues, ownProps.getSecondReminderFieldName(ownProps.formSectionName)),
  };
};

const BrandBarberCustomerReminderContainer = compose(
  getContext({
    _reduxForm: PropTypes.object,
  }),
  withMinuteOptions,
  withHandlers({
    getFirstReminderFieldName: props => formSectionName => firstReminderFieldName(formSectionName, props.name),
    getSecondReminderFieldName: props => formSectionName => secondReminderFieldName(formSectionName, props.name),
  }),
  connect(
    mapStateToProps,
    { change },
  ),
  handleReminderChange,
)(CustomerReminder);

export default BrandBarberCustomerReminderContainer;
